/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { BsFillPinFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import Cancel from "../../common/images/cancel.png";
import { staticFiles } from "../../components/Helpers/Static";
import { BsPin, BsPinFill } from "react-icons/bs"
import { MdArchive, MdOutlineUnarchive } from "react-icons/md"
import Archive from "../../common/images-new/archive.svg";
import { getUrl, serverUrl } from "../../components/Helpers/Config";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getCommunityGroups } from "../../redux/actions/communityGroups";
import { ActiveIconColor, Card, TextBlack, TextGray, ButtonCommonTopNew } from "../Theme";
import Swal from "sweetalert2";
import EditPhotoIcon from "../../common/images-new/edit-photo-icon.svg"
import ModalEditCover from "../../components/Modal/ModalEditCover";
import ModalProfile from '../../components/Modal/ModalProfile';
import { tokenAuthorize } from "../../components/Helpers/Common";
// import ProfileModal from "./ProfileModal";
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import $ from "jquery";
import CameraIcon from "../../common/images-new/camera-icon.png";
import Tooltip from "@mui/material/Tooltip";
import { RiUserFollowLine } from "react-icons/ri";
import { RiUserUnfollowLine } from "react-icons/ri";
import { TbArchiveFilled } from "react-icons/tb";
import { TbArchiveOff } from "react-icons/tb";
import { CommonLoader } from "../../components/Button/Loader";

let scrollPosition = 0;
let page = 0;
let isLoadingOffset = false;

function GroupCard({ item, is_student, is_tutor }) {

  const values = item.is_parent ? item.is_parent_archived : item.is_community_archived;

  const dispatch = useDispatch()
  const userProfile = useSelector(state => state.auth.user)
  const isLoadingOffset = useSelector(state => state.communityGroups.isLoadingOffset)
  const [show, setShow] = useState(false);
  const user = useSelector(state => state.auth.user)
  const [isPinned, setIsPinned] = useState(item.is_pinned)
  const [isArchived, setIsArchived] = useState(values);
  const [userItem, setuserItem] = useState([]);
  const [offset, setoffset] = useState(0);
  const [groupid, setgroupid] = useState(null);
  const [userItemLength, setuserItemLength] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setisOpenModal] = useState(false);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState("");
  const [showProfile, setShowProfile] = useState(false);
  const profilePhotoRef = useRef();
  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);
  const [cardImage, setCardImage] = useState("");
  const [groupMembers, setgroupMembers] = useState([]);
  const [groupMembersCount, setgroupMembersCount] = useState([]);
  const [newUser, setNewUser] = useState(false);
  const modalRef = useRef();
  const [isScrollling, setIsScrolling] = useState(false);


  const handleScroll = () => {
    const scrollTop = modalRef.current.scrollTop;
    scrollPosition = scrollTop;
    let offSetHeight = modalRef.current.offsetHeight;
    let scrollHeight = modalRef.current.scrollHeight;
    if (scrollTop > scrollHeight - offSetHeight - 1) {
      if (!newUser) {
        page = page + 5;
        $("#scrollLoader" + groupid).removeClass("hidden");
        axios.get(`${serverUrl.CommunityGroup}/members/${groupid}?offset=${page}`).then(res => {
          if (res.status === 200) {
            if (res.data.results.length > 0) {
              setuserItem((prevProfiles) => [...prevProfiles, ...res.data.results]);
              setNewUser(false);
            } else {
              setNewUser(true);
            }
            $("#scrollLoader" + groupid).addClass("hidden");
          }
        })
      }
    }
  }

  useEffect(() => {
    if (userItem?.length > 4 && modalRef?.current != null) {
      modalRef.current.scrollTop = scrollPosition;
    }
  }, [page, scrollPosition, newUser]);

  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile])

  useEffect(() => {
    getCardImage(item?.id, isTutor, isStudent);
    getCardMembers(item?.id, item?.is_parent);
  }, [item?.id])

  const getCardImage = (groupId, is_Tutor, is_Student) => {
    axios
      .get(`${serverUrl.CommunityGroupsImages}${groupId}?is_tutor=${is_Tutor}&is_student=${is_Student}`)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.groupCardImages?.length > 0) {
            setCardImage(response.data?.groupCardImages[0]?.card_image)
          }
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        console.log(error);
      });
  }

  const getCardMembers = (groupId, isParent) => {
    axios
      .get(`${serverUrl.CommunityGroupsMembers}${groupId}?is_parent=${isParent}`)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.members_count != null) {
            setgroupMembersCount(response.data.members_count);
          }
          if (response.data?.user_data && response.data?.user_data?.length > 0) {
            setgroupMembers(response.data?.user_data)
          } else {
            setgroupMembers([])
          }
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        console.log(error);
      });
  }

  const handleArchive = (e) => {
    e.stopPropagation();
    let archive = item.is_parent ? item.is_parent_archived : item.is_community_archived;
    if (!archive) {
      axios.post(
        serverUrl.CommunityGroup + `/archive/${item.id}`, { "is_parent": item.is_parent }
      ).then(resp => {
        if (resp.status === 200) {
          dispatch(getCommunityGroups(is_tutor, is_student))
        }
      })
    }
    else {
      axios.put(
        serverUrl.CommunityGroup + `/archive/${item.id}`, { "is_parent": item.is_parent }
      ).then(resp => {
        if (resp.status === 200) {
          dispatch(getCommunityGroups(is_tutor, is_student))
        }
      })
    }
  }

  const handleProfileUpload = (e) => {
    e.stopPropagation();
    profilePhotoRef.current.value = "";
    profilePhotoRef.current.click();
  }

  useEffect(() => {
    if (profilePhotoFile) {
      const objectURL = URL.createObjectURL(profilePhotoFile);
      setProfilePhoto(objectURL);
      return () => URL.revokeObjectURL(objectURL);
    }
  }, [profilePhotoFile]);

  const handleFeatImgChange = (e) => {
    const fileObject = e.target.files[0];
    if (!fileObject) return;
    setProfilePhotoFile(fileObject);
    setShowProfile(true)
  }

  function showMembers(e, id) {
    e.stopPropagation();
    page = 0;
    if (id !== null) {
      setShow(!show);
      setIsLoading(true);
      axios.get(`${serverUrl.CommunityGroup}/members/${id}?offset=${offset}`).then(res => {
        if (res.status === 200) {
          setgroupid(id);
          if (res.data.results?.length > 0) {
            setuserItem(res.data.results)
          }
          if (res.data.results.length === 5) {
            setNewUser(false);
          } else {
            setNewUser(true);
          }
          setIsLoading(false);
        }
      })
    }
    else {
      setShow(!show);
      setuserItem([]);
      setoffset(0);
    }
  }

  const updateGroupCardImage = (pic) => {
    setCardImage(pic);
  }

  const handleChangeFollow = (e, val) => {
    e.stopPropagation()
    let data = {
      "group_id": item.id,
      "is_follow": val
    }

    axios.put(
      serverUrl.CommunityGroupv2 + `/${userProfile.guid}`, data
    ).then(resp => {
      if (resp.status === 200) {
        if (val == true) {
          Swal.fire(
            {
              heightAuto: false,
              title: "Success",
              text: "Group followed successfully",
              icon: "success"
            }
          );
        }
        if (val == false) {
          Swal.fire(
            {
              heightAuto: false,
              title: "Success",
              text: "Group unfollowed successfully",
              icon: "success"
            }
          );
        }
        dispatch(getCommunityGroups(is_tutor, is_student))
      }
    })
  }

  const handleProfilePage = (userGid) => {
    $("#userItem" + userGid).addClass("cursor-not-allowed");
    axios.get(
      serverUrl.LoadUser1 + '/' + userGid
    ).then(resp => {
      if (resp.status === 200) {
        window.open(getUrl("/profile/") + userGid, "_blank");
      } else if (resp.status === 404) {
        Swal.fire({
          title: 'Information',
          text: 'This user has not created a Digital Portfolio yet',
          icon: 'info'
        })
      }
      $("#userItem" + userGid).removeClass("cursor-not-allowed");
    }).catch(err => {
      $("#userItem" + userGid).removeClass("cursor-not-allowed");
      if (err?.response?.status === 404) {
        Swal.fire({
          title: 'Information',
          text: 'This user has not created a Digital Portfolio yet',
          icon: 'warning'
        })
      }
      tokenAuthorize(err?.response?.status);
      console.log(err)
    });
  }

  const value = 2;
  const Members = () => {

    let style = show ? "flex" : "hidden";
    // style +=
    //   " flex justify-center items-center fixed top-0 left-0 w-screen h-screen  bg-black bg-opacity-30 z-10";
    return (
      <div className={style} onClick={(e) => e.stopPropagation()}>
        {isLoading ?
          <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
            <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`} id="cards">
              <div className='w-full flex items-center justify-center'>
                <CommonLoader />
              </div>
            </div>
          </div> :
          <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
            <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`} id="cards">
              <div className="flex gap-2 items-center justify-between">
                <p className="font-semibold blackColor">Members</p>
                <button
                  onClick={(e) => { showMembers(e, null) }}
                  className="text-gray-600 hover:text-black text-xl font-bold"
                >&times;
                </button>
              </div>
              <div className="overflow-y-auto h-64 scroll-smooth profile-modal pt-2" ref={modalRef} onScroll={handleScroll}>
                {userItem && userItem.map((userItem, index) => (
                  <div key={userItem.guid} className="p-2 flex gap-3 items-center" id={"userItem" + userItem.guid}>
                    <img src={userItem.photo ? userItem.photo : staticFiles.noProfilePic} className="rounded-full w-10 h-10" onClick={() => handleProfilePage(userItem.guid)} />
                    <div
                      className="text-lg blackColor custom_truncate"
                      onClick={() => handleProfilePage(userItem.guid)}
                    >
                      {userItem.fullname}
                    </div>
                  </div>
                ))}
              </div>
              <div className='w-full flex items-center justify-center pt-2 hidden' id={"scrollLoader" + groupid}>
                <CommonLoader />
              </div>
            </div>
          </div>
        }
      </div>
    );
  };
  return (<>
    {show && <Members />}
    <div className="w-full">
      <div className="relative flex justify-end">
        <div style={{ backgroundImage: "url(" + cardImage + ")", backgroundColor: (cardImage != null && cardImage != "") ? "" : item.is_parent ? '#7dea7d' : '#58a6e7' }}
          className="flex flex-col items-center justify-center w-full h-44 objectfit-cover background-repeatimage backimage-size"
        >
        </div>
        {
          <>
            {
              item.is_parent ? (!item.is_parent_archived ?
                <Tooltip title={"Click to archived"} placement="top" arrow>
                  <div className="absolute lg:top-4  md:top-4 left-2 sm:top-2">
                    <TbArchiveFilled
                      className="flex items-center cursor-pointer justify-center w-6 h-6 text-base font-semibold text-white rounded-full "
                      onClick={handleArchive}
                    /></div>
                </Tooltip> :
                <Tooltip title={"Click to active"} placement="top" arrow>
                  <div className="absolute top-4 left-2 lg:top-4 md:top-4 sm:top-2">
                    <TbArchiveOff className="flex items-center cursor-pointer justify-center w-6 h-6 text-base font-semibold text-white rounded-full "
                      onClick={handleArchive}
                    /></div>
                </Tooltip>
              ) :
                (!item.is_community_archived ?
                  <Tooltip title={"Click to archived"} placement="top" arrow>
                    <div className="absolute lg:top-4  md:top-4 left-2 sm:top-2">
                      <TbArchiveFilled
                        className="flex items-center cursor-pointer justify-center w-6 h-6 text-base font-semibold text-white rounded-full "
                        onClick={handleArchive}
                      /></div>
                  </Tooltip>
                  :
                  <Tooltip title={"Click to active"} placement="top" arrow>
                    <div className="absolute top-4 left-2 lg:top-4 md:top-4 sm:top-2">
                      <TbArchiveOff className="flex items-center cursor-pointer justify-center w-6 h-6 text-base text-white font-semibold rounded-full"
                        onClick={handleArchive}
                      /></div>
                  </Tooltip>
                )
            }
          </>
        }
        {isTutor &&
          <Tooltip title={"Edit cover image"} placement="top" arrow>
            <div className="absolute flex items-center CameraIcon w-7 h-7 rounded-full justify-center lg:top-4 md:top-4 sm:top-2 right-2" onClick={(e) => handleProfileUpload(e)}>
              <img
                className={"cursor-pointer"}
                src={CameraIcon} alt="edit profile"
              />
              <input
                className="hidden"
                ref={profilePhotoRef}
                type="file"
                id="imageUpload"
                accept="image/gif, image/jpeg, image/jpg, image/png, image/webp"
                onChange={handleFeatImgChange}
              />
            </div>
          </Tooltip>}
        <ModalProfile
          show={showProfile}
          setShow={setShowProfile}
          imgSrc={profilePhoto}
          imgCommunity={true}
          groupId={item.id}
          setgroupCardImage={(pic) => updateGroupCardImage(pic)}
        />

        {userProfile?.role == "MANAGER" ? "" :
          item.announcement_unread_count != 0 ?
            Number.isInteger(item.announcement_unread_count) &&
            <div className={`${item.announcement_unread_count.toString().length > 2 ? `absolute flex items-center justify-center w-7 h-7 text-xs font-semibold text-white bg-red-500 rounded-full ${isTutor ? "right-10" : "right-2"} lg:top-4 md:top-4 sm:top-2` : `absolute flex items-center justify-center w-7 h-7 text-xs font-semibold text-white bg-red-500 rounded-full ${isTutor ? "right-10" : "right-2"} lg:top-4 md:top-4 sm:top-2`}`}>{item.announcement_unread_count}
            </div> : ""}
        {item.is_parent == false &&
          <div className="flex absolute lg:top-4 md:top-4 sm:top-2 left-10">
            {item.allow_follow == true && <>
              {item.is_follow == true ?
                <button className="follow-button flex gap-1 items-center" onClick={(e) => handleChangeFollow(e, false)}><RiUserUnfollowLine className="text-black" />Unfollow</button> :
                <button className="follow-button flex gap-1 items-center" onClick={(e,) => handleChangeFollow(e, true)}><RiUserFollowLine className="text-black" />Follow</button>
              }</>
            }
          </div>}

      </div>
      <div className="pt-4 pb-2 px-5">
        <div className="w-full flex justify-center font-bold blackColor text-lg">
          {item.name}
        </div>
        <div className="w-full flex justify-center lightColor text-lg">
          {item.posts} post{item.posts > 1 && "s"} on this group
        </div>
        {item.desc && <div className="py-2">{item.desc}</div>}
        <div className="flex flex-row justify-between py-2">
          <div className="text-base font-semibold blackColor">Members</div>
          <div className="blueColor cursor-pointer font-semibold hover:underline text-right" onClick={(e) => { showMembers(e, item.id) }}>
            View all {groupMembersCount} members
          </div>
        </div>
        {groupMembers?.length != 0 &&
          < div className="flex gap-2 w-full relative mb-4">
            {groupMembers
              ?.filter((_, idx) => idx < 5)
              .map((mem, index) => (
                <div key={index} className="flex justify-center">
                  <Tooltip title={mem?.name} placement="top" arrow>
                    <Link
                      to={mem.link}
                      target="_blank"
                    >
                      <img
                        src={mem.photo ? mem.photo : staticFiles.noProfilePic}
                        className="w-10 h-10 rounded-full object-cover"
                        alt={mem.name}
                        onClick={(e) => { e.stopPropagation() }}
                      />
                    </Link>
                  </Tooltip>
                </div>
              ))}
            {
              groupMembers?.length > 5 &&
              <div className="w-10 h-10 backGroundColor blueColor rounded-full justify-center font-semibold flex text-sm items-center">
                {groupMembers?.length - 5}+
              </div>
            }
          </div>
        }
      </div>
    </div>
  </>);
}

export default GroupCard;
